import React from 'react';
import { CheckboxInput } from '@awarego-ui/components';
import HtmlField from '../../../components/inputs/htmlField';
import SmartVariablesPanel from './SmartVariablesPanel';

const NOTE_TEXT =
    'Note: Only default texts are automatically translated into the user’s language. Any changes you make turn the text into a custom version that is used exactly as written. When the checkbox is off, the translated default text is used; when it’s on, your custom content is used.';

const WelcomeMessageTab = ({
    form,
    initialValue,
    smartVariables,
    onCopyVariable,
    onEnabledChange,
}) => {
    const field = form.$('welcomeMessage');
    const enabledField = form.$('welcomeMessageEnabled');
    const mrkdownField = form.$('mrkdwn_welcomeMessage');
    const isEnabled = enabledField.value === '1';

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        const currentValue = field.value;
        enabledField.set(checked ? '1' : '0');

        if (checked) {
            if (currentValue === undefined || currentValue === null) {
                field.set('');
            }
            onEnabledChange && onEnabledChange('welcomeMessage', currentValue || '');
        }
    };

    return (
        <div className="row">
            <div className="col-md-8">
                <br />
                <p
                    style={{
                        fontSize: '14px',
                        color: '#666',
                        fontStyle: 'italic',
                        marginBottom: '16px',
                    }}
                >
                    {NOTE_TEXT}
                </p>
                <div className="form-group">
                    <CheckboxInput
                        label="Customize Welcome Message"
                        checked={isEnabled}
                        onChange={handleCheckboxChange}
                    />
                    {isEnabled && (
                        <HtmlField
                            field={field}
                            mrkdownField={mrkdownField}
                            showLabel={true}
                            initialValue={initialValue}
                        />
                    )}
                </div>
            </div>
            <div className="col-md-4">
                <SmartVariablesPanel
                    variables={smartVariables}
                    onCopyVariable={onCopyVariable}
                />
            </div>
        </div>
    );
};

export default WelcomeMessageTab;

